import React from 'react'

function ProjectCard({
  skills,
  title,
  description,
  image,
  techStack,
  gitLink,
  blogLink,
  features,
  responsibilities,
  hostLink,
  award,
  handleRobotText,
  remarks
}) {
  const [modal, setModal] = React.useState(false);
  return (
    <>
      <div
        className="project glass flexBox"
        onClick={() => setModal(true)}
        onMouseEnter={() =>remarks && handleRobotText(remarks)}
      >
        {award && <div className="award">Awarded</div>}
        <img src={image} alt="Main" />
        <div className="display flexBox">
          {award && (
            <div className="awardLogo">
              <img
                src={process.env.PUBLIC_URL + "/images/award.png"}
                alt="Logo"
              />
            </div>
          )}
          <h1>{title}</h1>
          <p>{description}</p>
          <button>Read More</button>
        </div>
      </div>
      {modal && (
        <div className="projectModal flexBox" onClick={() => setModal(false)}>
          <div className="projectModalContainer">
            <div
              className="closeBox glass light flexBox "
              onClick={() => setModal(false)}
            >
              <p>Close</p>
              <button>X</button>
            </div>
            <div
              className="projectModalBox scroll"
              onClick={(e) => e.stopPropagation()}
            >
              <img src={image} alt="Main" />
              <div className="display flexBox">
                {award && (
                  <div className="awardLogo">
                    <img
                      src={process.env.PUBLIC_URL + "/images/award.png"}
                      alt="Logo"
                    />
                  </div>
                )}
                <h1>{title}</h1>
                <div className="projectDescription flexBox">
                  <p>{description}</p>
                  <div className="projectLinks flexBox">
                    {gitLink && (
                      <a
                        href={gitLink}
                        target="_blank"
                        className="glass"
                        rel="noopener noreferrer"
                      >
                        Code
                      </a>
                    )}
                    {blogLink && (
                      <a
                        href={blogLink}
                        target="_blank"
                        className="glass"
                        rel="noopener noreferrer"
                      >
                        Blog
                      </a>
                    )}
                    {hostLink && (
                      <a
                        href={hostLink}
                        target="_blank"
                        className="glass"
                        rel="noopener noreferrer"
                      >
                        Demo
                      </a>
                    )}
                  </div>
                </div>

                <div className="projectDetails flexBox">
                  <div>
                    <h2>Features</h2>
                    <ul className="features">
                      {features
                        .split(".")
                        .map(
                          (feature) =>
                            feature.trim() && <li>{feature.trim()}.</li>
                        )}
                    </ul>
                    {responsibilities && (
                      <>
                        <h2>Responsibilities</h2>
                        <ul className="features">
                          {responsibilities
                            .split(".")
                            .map(
                              (feature) =>
                                feature.trim() && <li>{feature.trim()}.</li>
                            )}
                        </ul>
                      </>
                    )}
                  </div>
                  <div>
                    <h2>Tech Stacks</h2>
                    <div className="techStackContainer flexBox">
                      {skills
                        .filter((item) =>
                          techStack
                            .toLowerCase()
                            .includes(item.title.toLowerCase())
                        )
                        .map((skill) => (
                          <div
                            key={skill.title}
                            className="skillBox glass light flexBox"
                          >
                            <img src={skill.image} alt="logo" />
                            <p>{skill.title}</p>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ProjectCard
